import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageSlotModule } from '@spartacus/storefront';
import { ConfigModule, I18nModule } from '@spartacus/core';
import { PrimengModule } from '../primeng/primeng.module';
import { FormsModule } from '@angular/forms';
import { SGRESharedModule } from '../../SGRE-shared/SGRE-shared.module';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
  TranslateStore,
} from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { HttpBackend } from '@angular/common/http';
import { HomepageCarouselSection1Component } from './components/homepage-carousel-section1/homepage-carousel-section1.component';
import { HomepageTopProductsSection2Component } from './components/homepage-top-products-section2/homepage-top-products-section2.component';
import { HomepageCategorySection3Component } from './components/homepage-category-section3/homepage-category-section3.component';
import { HomepageSection5LinksComponent } from './components/homepage-section5-links/homepage-section5-links.component';
import { StoreModule } from '@ngrx/store';
import { HomePageReducer } from '../homepage/store/reducer/index';
import { HomePageEffects } from './store/effects/homepage.effects'
import { HOME_PAGE_FEATURE } from './store/homepage.state';
import { EffectsModule } from '@ngrx/effects';
import { HomePageEffectsService } from './store/effects/homepage-effects.service';
import { GalleriaModule } from 'primeng/galleria';

export function HttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, ['/public/i18n/core/', '/public/i18n/vendors/']);
}

@NgModule({
  declarations: [
    HomepageCarouselSection1Component,
    HomepageTopProductsSection2Component,
    HomepageCategorySection3Component,
    HomepageSection5LinksComponent
  ],
  imports: [
    CommonModule,
    PageSlotModule,
    PrimengModule,
    FormsModule,
    SGRESharedModule,
    GalleriaModule,
    StoreModule.forFeature(HOME_PAGE_FEATURE, HomePageReducer),
    EffectsModule.forFeature(HomePageEffects),
    ConfigModule.withConfig({
      cmsComponents: {
        RotatingImagesComponent: {
          component: HomepageCarouselSection1Component,
        },
        TopFeaturedProductsFlexComponent: {
          component: HomepageTopProductsSection2Component,
        },
        HomepageCategoryComponent: {
          component: HomepageCategorySection3Component,
        },
        SignInAndRequestAccessFlexComponent: {
          component: HomepageSection5LinksComponent,
        },
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend]
      }
    }),
    I18nModule
  ],
  providers: [
    TranslateService,
    HomePageEffectsService,
    { provide: TranslateStore }
  ]
})
export class HomepageModule { }